<template>
  <div class="grab-chart">
    <div :id="chartId" class="ct-chart"></div>
  </div>
</template>
<script>
export default {
  name: 'chart-card',
  props: {
    chartType: {
      type: String,
      default: 'Line' // Line | Pie | Bar
    },
    chartOptions: {
      type: Object,
      default: () => {
        return {
          seriesBarDistance: 30,
          axisX: {
            showGrid: false,
            showLabel: false
          },
          height: '280px'
        }
      }
    },
    chartData: {
      type: Object,
      default: () => {
        return {
          labels: [],
          series: []
        }
      }
    }
  },
  watch: {
    chartData: function (data) {
      if (this.chart) {
        this.chart.update(data);
      }
    }
  },
  async mounted () {
    this.updateChartId()
    const Chartist = await import('chartist')
    this.$Chartist = Chartist
    this.initChart()
  },
  data () {
    return {
      chartId: 'no-id',
      $Chartist: null,
      chart: null
    }
  },
  methods: {
    /***
     * Initializes the chart by merging the chart options sent via props and the default chart options
     */
    initChart () {
      var chartIdQuery = `#${this.chartId}`
      var chartOptions = this.chartOptions;
      // chartOptions.axisX.type = this.$Chartist.AutoScaleAxis;
      this.chart = this.$Chartist[this.chartType](chartIdQuery, this.chartData, chartOptions)
    },
    redrawChart () {
      this.chart.update(this.chartData);
    },
    /***
     * Assigns a random id to the chart
     */
    updateChartId () {
      var currentTime = new Date().getTime().toString()
      var randomInt = this.getRandomInt(0, currentTime)
      this.chartId = `div_${randomInt}`
    },
    getRandomInt (min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min
    }
  },
}
</script>
<style>
.grab-chart .ct-series-b .ct-point, .grab-chart .ct-series-b .ct-line, .grab-chart .ct-series-b .ct-bar, .grab-chart .ct-series-b .ct-slice-donut {
  stroke: #7AC29A!important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/GrabProcess/List/CurrentJob/GrabChart.vue